import { Button, ButtonColor, ButtonTypes } from "@repo/ui";

import { useUpdateRoute } from "../../../../helpers/urlHooks";

export default function PortalLink(props: Props) {
	const updateRoute = useUpdateRoute();

	function onClick() {
		updateRoute(props.entityId, props.entityType);
	}

	return (
		<Button color={ButtonColor.DarkBlue} types={[ButtonTypes.Text]} onClick={onClick}>
			{props.name}
		</Button>
	);
}

interface Props {
	entityId: number;
	entityType: string;
	name: string;
}
